import styled from "styled-components";
import React from "react";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;
	width: auto;
	max-width: 100%;
`;

export const TopContainer = styled.div`
	margin: ${(props) => props.theme.spacing};
	max-width: ${(props) => props.theme.max};
	width:100%;
	@media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;

export const Title = styled.h1`
	color: #070808;
	font-family: Mallory-Book;
	font-size: 40px;
	font-weight: 300;
	letter-spacing: 0.63px;
	line-height: 40px;
	text-align: center;
	margin: 17px 0;
`;

export const Category = styled.p`
	color: #747474;
	font-family: Mallory;
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 14px;
	text-align: center;
	margin: 48px 0 0 0;
	text-transform: uppercase;
	@media (max-width: 767px) {
		margin-top: 30px;
	}
`;

export const Blurb = styled.div`
	p {
	max-width: 816px;
	color: #747474;
	font-size: 20px;
	font-weight: 300;
	letter-spacing: 0.31px;
	line-height: 32px;
	text-align: center;
	font-family: Mallory-Book;
	margin: auto;
	font-family: Mallory-Book;
	}
	a {
		color: inherit;
		font-family: Mallory-Book;
	}
	@media (max-width: 767px) {
		margin: 18px 18px 0;
	}
`;

export const FeaturedImage = styled.img`
	height: 524px;
	width: 100%;
	object-fit: cover;
	@media (max-width: 767px) {
		max-height: 159px;
	}
`;

export const Date = styled.p`
	color: #747474;
	font-family: Mallory-Book;
	font-size: 12px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 14px;
	text-align: center;
	margin-top: 23px;
	@media (max-width: 767px){
		margin-top: 18px;
		margin-bottom: 0;
	}
`;